
import Vue from "vue";
import { Permissions } from "../../models/user-configs/permissions";
import AppBrowseRow from "./UserPermissionsBrowseRow.vue";
import AppPermissionToggle from "./UserPermissionToggle.vue";
import { SaleService } from "../../services/sale-service";
import { ISelectItem } from "winfakt-vue-components";
import { SaleType } from "@/models/base";
import { UserInfo } from "../../models/dossier/user-info";
import { DossierService } from "../../services/dossier-service";
import { UserConfigService } from "../../services/user-config-service";
import { BROWSE_ACCESS_LEVELS, BrowseAccessLevel } from "../../models/user-configs/browse-permissions";

type FeatureToggleKey = "CanSeeDashboard" | "CanReadProductPurchaseDetails" | "CanApproveInboxPurchases" | "CanMakeReports";

export default Vue.extend({
	data(){
		return {
			saleTypes: [] as SaleType[],
			purchaseTypes: [] as SaleType[],
			allUsers: [] as UserInfo[],
			copySettingsModal: false,
			allExpanded: false
		};
	},
	props: {
		value: {
			type: Permissions,
			required: true
		},
		user: {
			type: Object as ()=>UserInfo,
			required: true
		},
		buttonsOnly: Boolean
	},
	computed: {
		saleTypeItems():ISelectItem<number>[]{
			return this.saleTypes.map(s=>{
				return {
					value: s.ID,
					text: s.Name.getTranslation(this.$i18n.locale)
				};
			});
		},
		purchaseTypeItems():ISelectItem<number>[]{
			return this.purchaseTypes.map(s=>{
				return {
					value: s.ID,
					text: s.Name.getTranslation(this.$i18n.locale)
				};
			});
		},
		managableSaleDocTypes: {
			get():number[] {
				return this.value.ManagableSaleTypes.filter(id=>this.saleTypes.some(t=>t.ID == id));
			},
			set(ids:number[]) {
				this.setManagableTypes(ids, this.saleTypes);
			}
		},
		managablePurchaseDocTypes: {
			get():number[] {
				return this.value.ManagableSaleTypes.filter(id=>this.purchaseTypes.some(t=>t.ID == id));
			},
			set(ids:number[]) {
				this.setManagableTypes(ids, this.purchaseTypes);
			}
		},
		accessLevels():BrowseAccessLevel[]{
			return BROWSE_ACCESS_LEVELS;
		},
		featureToggles():{key:FeatureToggleKey, i18n:string}[]{
			return [
				{key: "CanSeeDashboard", i18n: "can-see-dashboard"},
				{key: "CanReadProductPurchaseDetails", i18n: "can-see-buy-prices"},
				{key: "CanApproveInboxPurchases", i18n: "can-approve-inbox-purchases"},
				{key: "CanMakeReports", i18n: "can-make-reports"}
			];
		},
		extraOptions():ISelectItem<string>[]{
			return [
				{
					text: this.$ct("copy-settings"),
					value: "copy-settings"
				},
			];
		}
	},
	methods: {
		setAllLevels(level:BrowseAccessLevel){
			for (let permissions of this.value.getAllBrowsePermissions()) {
				permissions.setAccessLevel(level);
			}
		},
		setFeature(key:FeatureToggleKey, enabled:boolean){
			this.value[key] = enabled;
		},
		setManagableTypes(ids:number[], types:SaleType[]){
			let otherTypeIds = this.value.ManagableSaleTypes.filter(id=>!types.some(t=>t.ID == id));
			this.value.ManagableSaleTypes = [...otherTypeIds, ...ids];
		},
		extraOptionClicked(option:string){
			if (option == "copy-settings"){
				this.copySettingsModal = true;
			}
		},
		closeCopySettings(){
			this.copySettingsModal = false;
		},
		async copySettingsFromUser(id:number){
			let settings = await UserConfigService.getUsersPermissions(id);
			this.$emit("input", settings);
			this.copySettingsModal = false;
		}
	},
	async created(){
		this.saleTypes = SaleService.getTypes().filter(t=>t.ID != 10);
		this.purchaseTypes = SaleService.getTypes(2);
		this.allUsers = await DossierService.getUsers();
	},
	components: {
		AppBrowseRow,
		AppPermissionToggle
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
